import React from "react";
import ChangeRequestFormContent from "src/components/Form/ChangeRequest/ChangeRequestFormContent";
import { ContentSectionProps } from "./type";

export const ContentSection: React.FC<ContentSectionProps> = ({
  formValues,
}) => {
  return <ChangeRequestFormContent formValues={formValues} />;
};
